import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import type { Tour } from "@/content/tours";
import { tourForPath } from "@/content/tourRoutes";

/** The guided tour for the current route, if it has one. */
export function useTourForRoute(): Tour | null {
  const { pathname } = useLocation();
  return useMemo(() => tourForPath(pathname), [pathname]);
}
